export enum LogLevel {
  VERBOSE = "verbose",
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
  CRITICAL = "critical",
}
export type LogRequest = {
  level: LogLevel;
  message: string;
  error?: string;
  component: string;
  data?: Record<string, string>;
};
